<template>
  <div>
    <v-btn
      small
      class="i-btn-block-secondary mb-2"
      :disabled="disabled"
      @click="handleClick"
    >
      {{ buttonText }}
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'RetailerListActionButton',

  props: {
    supplierId: {
      type: Number,
      required: true
    },
    selectedRetailers: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'useOnly',
      validator: (v) => ['full', 'useOnly'].includes(v)
    },
    savedListApplied: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('supplierRetailerRange', ['savedRetailerIds']),

    hasSaved() {
      return this.savedRetailerIds?.length > 0
    },

    isSameList() {
      const selectedSet = new Set(this.selectedRetailers)
      const savedSet = new Set(this.savedRetailerIds)
      return (
        this.selectedRetailers.length === this.savedRetailerIds.length &&
        [...selectedSet].every((id) => savedSet.has(id))
      )
    },

    shouldSaveList() {
      return (
        this.mode === 'full' &&
        (!this.hasSaved || (this.savedListApplied && !this.isSameList))
      )
    },

    buttonText() {
      if (!this.hasSaved) {
        return this.mode === 'full'
          ? 'Save Retailer List'
          : 'No Saved Retailers Found'
      }

      if (!this.savedListApplied) {
        return 'Use Saved Retailer List'
      }

      if (this.mode === 'full' && !this.isSameList) {
        return 'Save Retailer List'
      }

      return 'Saved Retailer List (Applied)'
    }
  },

  created() {
    if (this.supplierId) {
      this.fetchSavedRetailerList(this.supplierId)
    } else {
      console.warn(
        '[RetailerListActionButton] supplierId is undefined — skipping fetch'
      )
    }
  },

  methods: {
    ...mapActions('supplierRetailerRange', [
      'fetchSavedRetailerList',
      'saveRetailerList'
    ]),

    handleClick() {
      if (this.shouldSaveList) {
        // Only allowed in full mode
        this.saveRetailerList({
          supplierId: this.supplierId,
          retailerIds: this.selectedRetailers
        }).then(() => {
          this.$emit('saved')
          if (this.savedListApplied) {
            this.$emit('apply', [...this.savedRetailerIds])
          }
        })
      } else if (!this.savedListApplied && this.hasSaved) {
        // Only apply if not already applied
        this.$emit('apply', [...this.savedRetailerIds])
      }
    }
  }
}
</script>
